<!-- eslint-disable max-len -->
<template>
  <div
    v-if="lstDestination.length === 0"
    :id="id"
    class="c-grid c-section c-content--sendPoint c-scrollbar"
  >
    <div class="c-grid--service c-content--package-add">
      <div class="c-section--content-article text-center">
        <!-- <div class="c-box--img-floating c-text-center">
          <img src="~@/assets/img/service-paquete.svg" alt="package" />
        </div> -->
        <article class="c-grid--services__item text-center">
          <ul>
            <li>
              Debes agregar por lo menos un <br />
              producto para tu envío
            </li>
          </ul>
        </article>
        <div class="pt-2 pb-2">
          <div class="c-content--buttond-add d-flex justify-content-center" style="cursor: pointer">
            <a
              @click.prevent="addPackage"
              class="c-btn-popup-slide d-flex align-items-center color-black font-weight-ligth p-1 c-content--box-shadow"
              ><img
                src="~@/assets/img/icon/icon-add.svg"
                alt="Agregar"
                width="34"
                height="34"
                class="mr-1"
              />Agregar paquete
            </a>
          </div>
        </div>

        <article class="c-grid--services__item pb-1">
          <div class="calculate-font text-center c-content--line-half">Ó</div>
          <br />
          <h2 class="">¿Envías más de un pedido?</h2>
          <p>Descarga siempre la última versión de la plantilla.</p>
          <article
            class="c-grid--services__item mt-1 d-flex justify-content-center"
          >
            <a
              href="javascript:void(0)"
              @click="downloadExcel"
              class="c-button c-button--seven c-button--width-fuid c-button--mobile-small waves-effect d-flex align-items-center justify-content-center w-80"
              ><img
                src="~@/assets/img/icon/icon-dowloand-button.svg"
                alt=""
                class="mr-1"
              />Descargar plantilla</a
            >
          </article>

          <div>
            <upload-zone
              @getFiles="setExcelFile"
              :filetypes="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xls, .xlsx'"
              :allowMultiple="false"
            />
          </div>
          <!-- <div class="c-text-format">Adjunte solo Excel</div> -->
        </article>

        <br />
        <br />
      </div>
    </div>
  </div>
  <div
    v-else
    class="c-section--content-shadow c-content--sendPoint c-scrollbar c-content--app_container"
  >
    <div
      id=""
      class="c-modal m-0"
      v-for="(item, index) in lstDestination"
      v-bind:key="index"
    >
      <div
        class="c-modal--directions-title information-package pt-1 pb-1 border-radius-above"
      >
        <h2 class="c-text-left">{{ item.description }}</h2>
        <p
          v-if="
            item.packageSize.type === 'Pequeno' ||
            item.packageSize.type === 'Pequeño'
          "
        >
          Paquete Pequeño
        </p>
        <p v-else-if="item.packageSize.type === 'Mediano'">Paquete Mediano</p>
        <p v-else-if="item.packageSize.type === 'Grande'">Paquete Grande</p>
        <p v-else>Paquete Pesonalizado</p>
        <a @click="deleteDestinationAddress(index)" class="cursor-pointer"
          ><img src="~@/assets/img/icon/icon-closex.svg" alt=""
        /></a>
      </div>
      <div
        id="profile"
        class="c-grid c-section--content-favorite c-m-top-for-nav-md"
      >
        <div
          class="c-grid--services__container-m c-content--box-shadow border-radius-below"
        >
          <div class="c-section--content-article">
            <article class="c-grid--services__item c-section--dateContent pt-2">
              <div class="c-section--content-package-information">
                <div class="item-package-information">
                  Alto:
                  <p>{{ item.packageSize.height }} cm</p>
                </div>
                <div class="item-package-information">
                  Ancho:
                  <p>{{ item.packageSize.width }} cm</p>
                </div>
                <div class="item-package-information">
                  Largo:
                  <p>{{ item.packageSize.lengths }} cm</p>
                </div>
                <div class="item-package-information">
                  Valor:
                  <p>S/ {{ item.productValue }}</p>
                </div>
              </div>
            </article>
            <article class="c-grid--services__item c-section--dateContent">
              <article
                class="c-grid--services__item c-section--article c-section--before-none c-content--contact-package"
              >
                <div class="c-flex">
                  <div class="c-icon-person">
                    <img src="@/assets/img/icon/icon-user.svg" alt="" />
                  </div>
                  <div class="content-article-directions">
                    <div class="c-section--article-paragraph-n">
                      {{ item.destinationAddress.contact.name }}
                    </div>
                    <div class="c-section--article-paragraph">
                      N° {{ item.destinationAddress.contact.phone }}
                    </div>
                  </div>
                </div>
                <div class="row m-0">
                  <div class="col s6">
                    <button
                      @click="editDestinationAddress(item, index)"
                      class="c-button c-button--seven c-button--width-fuid c-button--mobile-small waves-effect"
                    >
                      Editar
                    </button>
                  </div>
                  <div class="col s6">
                    <button
                      @click="deleteDestinationAddress(index)"
                      class="c-button c-button--eight c-button--width-fuid c-button--mobile-small waves-effect"
                    >
                      Borrar
                    </button>
                  </div>
                </div>
              </article>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadZone from "../../General/UploadZone.vue";

export default {
  name: "Step3-Content-PuntoScharff",
  components: {
    UploadZone,
  },
  props: {
    id: String,
  },
  data() {
    return {
      excelFile: null,
    };
  },
  methods: {
    setExcelFile(files) {
      this.excelFile = files;
      this.$store.dispatch("SCHARFFPOINT_FILE", this.excelFile);
    },
    deleteDestinationAddress(index) {
      this.$store.dispatch("SCHARFFPOINT_ORDER_DELETE_DESTINATION", index);
    },
    editDestinationAddress(destination, index) {
      this.$store.dispatch("SCHARFFPOINT_ORDER_SET_INDEX_DESTINATION", index);
      this.$eventBus.$emit("scharffPointSetDataDestinationModal", destination);
      const modalpackage = document.querySelector("#modal-package");
      modalpackage.classList.add("is-active");
      document.getElementById("scharffPoint-step-3-modal-pop").value = destination.destinationAddress.districtId.text;

      this.trackEvent('click_puntos_envia_paso_3_editar_paquete', 'dropoff/puntoapunto')
    },
    addPackage() {
      this.$eventBus.$emit("scharffPointClearDataDestinationModal");
      this.$store.dispatch("SCHARFFPOINT_ORDER_SET_INDEX_DESTINATION", 0);
      const modalpackage = document.querySelector("#modal-package");
      // document.getElementById("scharffPoint-step-3-modal-pop").value = "";
      modalpackage.classList.add("is-active");

      this.trackEvent('click_puntos_envia_paso_3_agregar_paquete', 'dropoff');
    },
    async downloadExcel() {
      this.showLoading();
      await this.$store
        .dispatch("GET_EXCEL_TEMPLATE_PS_ENVIO")
        .then((success) => {
          this.$swal.close();
          if (success.status === 200) {
            const url = window.URL.createObjectURL(new Blob([success.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `PUNTO_SCHARFF_ENVIO_${this.getCurrentStringDate()}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            this.trackEvent('click_puntos_envia_paso_3_descargar_plantilla', 'dropoff')
          } else {
            this.showError(success.data.message);
          }
        })
        .catch((error) => {
          const catchMsg = this.catchStandardErrorMsg(error);
          this.$swal.close();
          this.showError(catchMsg);
        });
    },
  },
  computed: {
    lstDestination() {
      return this.$store.getters.SCHARFFPOINT_ORDER_DESTINATION;
    },
  },
};
</script>
